import React, { createRef } from 'react';
import { Picture } from 'react-responsive-picture';
import store from '../../common/store';
import {changePage, setResult} from '../../common/actions/page-actions';

import Button from '../../components/Button';
import Checkbox from '../../components/Checkbox';

import './styles.scss';

const questions = [
  {
    title: "Вы пригласили друзей к себе. Как проходит ваш вечер?",
    val1: "1",
    val2: "2"
  },
  {
    title: "Представим, что у друзей есть дети. Как пройдет вечеринка?️",
    val1: "2",
    val2: "1"
  },
  {
    title: "Друг слушает музыку, которая вам не нравится. Что делать?",
    val1: "1",
    val2: "2"
  },
  {
    title: "Нужно выбрать классный подарок для друга. вы:",
    val1: "1",
    val2: "2"
  },
  {
    title: "Вы пообещали, что позавтракаете с друзьями. Как пройдёт ваше утро?",
    val1: "1",
    val2: "2"
  },
  {
    title: "Если вы с друзьями делаете совместное фото, как оно выглядит?",
    val1: "1",
    val2: "2"
  }
];

class Question extends React.Component {
    form = createRef();

    handleClickPrev = () => {
      store.dispatch(changePage(this.props.number - 1));
    }

    onSelect = (question, answer) => () => {
      window.xray('answer_button', JSON.stringify({ question, answer }));
    }

    checkImg = () => {
      this.sendData({ target: this.form.current });
    }

    sendData = (e) => {
      e.preventDefault && e.preventDefault();

      const form = e.target.tagName.toLowerCase() === 'form' ? e.target : e.target.form;
      const resultField = form.querySelector(':checked');
      let currentResult = this.props.result;

      if (currentResult.length && currentResult[this.props.number - 1]) {
        currentResult[this.props.number - 1] = +resultField.value;
      } else {
        currentResult.push(+resultField.value);
      }

      store.dispatch(setResult(currentResult));
      store.dispatch(changePage(this.props.number + 1));
    }

    render() {
        const number = this.props.number - 1;
        const questionsNum = questions[number];

        return (
          <div className="page__content">
            <form ref={this.form} className="question">
              <h2 className="question__title">{questionsNum.title}</h2>
              <div className="question__answer">
                <label className="question__choice">
                  <Checkbox
                    type="radio"
                    name={`question${number}`}
                    value={questionsNum.val1}
                    handleChange={this.checkImg} />
                  <span onClick={this.onSelect(number + 1, questionsNum.val1)}>
                    <Picture
                      sources = {[
                        {
                          srcSet: `./static/media/question/question-${this.props.number}-1-1024.jpg 1x, ./static/media/question/question-${this.props.number}-1-1024@2x.jpg 2x `,
                          media: "(max-width: 1279px)",
                        },
                        {
                          srcSet: `./static/media/question/question-${this.props.number}-1-1280.jpg 1x, ./static/media/question/question-${this.props.number}-1-1280@2x.jpg 2x `,
                          media: "(min-width: 1280px) and (max-width: 1439px)",
                        },
                        {
                          srcSet: `./static/media/question/question-${this.props.number}-1-1440.jpg 1x, ./static/media/question/question-${this.props.number}-1-1440@2x.jpg 2x `,
                          media: "(min-width: 1440px) and (max-width: 1689px)",
                        },
                        {
                          srcSet: `./static/media/question/question-${this.props.number}-1-1690.jpg 1x, ./static/media/question/question-${this.props.number}-1-1690@2x.jpg 2x `,
                          media: "(min-width: 1690px) and (max-width: 1919px)",
                        },
                        {
                          srcSet: `./static/media/question/question-${this.props.number}-1-1920.jpg 1x, ./static/media/question/question-${this.props.number}-1-1920@2x.jpg 2x `,
                          media: "(min-width: 1920px) and (max-width: 2559px)",
                        },
                        {
                          srcSet: `./static/media/question/question-${this.props.number}-1-2500.jpg 1x, ./static/media/question/question-${this.props.number}-1-2500@2x.jpg 2x `,
                          media: "(min-width: 2560px)",
                        },
                        {
                          srcSet: `./static/media/question/question-${this.props.number}-1-2500.jpg 1x, ./static/media/question/question-${this.props.number}-1-2500@2x.jpg 2x`
                        }
                      ]}
                      src={`./static/media/question/question-${this.props.number}-1-2500.jpg`}
                      alt=""
                    />

                  </span>
                </label>
                <label className="question__choice">
                  <Checkbox
                    type="radio"
                    name={`question${number}`}
                    value={questionsNum.val2}
                    handleChange={this.checkImg} />
                  <span onClick={this.onSelect(number + 1, questionsNum.val2)}>
                    <Picture
                      sources = {[
                        {
                          srcSet: `./static/media/question/question-${this.props.number}-2-1024.jpg 1x, ./static/media/question/question-${this.props.number}-2-1024@2x.jpg 2x `,
                          media: "(max-width: 1279px)",
                        },
                        {
                          srcSet: `./static/media/question/question-${this.props.number}-2-1280.jpg 1x, ./static/media/question/question-${this.props.number}-2-1280@2x.jpg 2x `,
                          media: "(min-width: 1280px) and (max-width: 1439px)",
                        },
                        {
                          srcSet: `./static/media/question/question-${this.props.number}-2-1440.jpg 1x, ./static/media/question/question-${this.props.number}-2-1440@2x.jpg 2x `,
                          media: "(min-width: 1440px) and (max-width: 1689px)",
                        },
                        {
                          srcSet: `./static/media/question/question-${this.props.number}-2-1690.jpg 1x, ./static/media/question/question-${this.props.number}-2-1690@2x.jpg 2x `,
                          media: "(min-width: 1690px) and (max-width: 1919px)",
                        },
                        {
                          srcSet: `./static/media/question/question-${this.props.number}-2-1920.jpg 1x, ./static/media/question/question-${this.props.number}-2-1920@2x.jpg 2x `,
                          media: "(min-width: 1920px) and (max-width: 2559px)",
                        },
                        {
                          srcSet: `./static/media/question/question-${this.props.number}-2-2500.jpg 1x, ./static/media/question/question-${this.props.number}-2-2500@2x.jpg 2x `,
                          media: "(min-width: 2560px)",
                        },
                        {
                          srcSet: `./static/media/question/question-${this.props.number}-2-2500.jpg 1x, ./static/media/question/question-${this.props.number}-2-2500@2x.jpg 2x`
                        }
                      ]}
                      src={`./static/media/question/question-${this.props.number}-2-2500.jpg`}
                      alt=""
                    />
                  </span>
                </label>
              </div>
              <div className="question__button">
                <Button
                    class="-gray -size-s"
                    name="назад"
                    onClick={this.handleClickPrev}
                    xray="back_button"
                />
              </div>
            </form>
          </div>
        )
    }
}

export default Question;
